import React from 'react';
import { RecallsUnitedContent } from '../../pages/recalls-united/hooks/use-recalls-united-content';
import { nameplateMakeModelYearUtil } from '../../../components/utils/nameplate-model-year-util/nameplate-make-model-year-util';
import RecallsListMobile from '../recalls-lists-mobile/recalls-list-mobile';
import './recalls-information-section.scss';
import { ActivityIndicator } from '../../../components/common/activity-indicator/activity-indicator';
import { useExemptWordsContent } from '../../pages/recalls/hook/use-exempt-word-list';
import errorIcon from '../../../assets/Error.svg';
import { useBreakpoints } from '../../../hooks/use-breakpoints';
import RecallsListDesktop from '../recalls-list-desktop/recalls-list-desktop';
import { RecallsApiResponseWithLoading } from '../../../components/sections/vehicle-portal/hooks/use-recall-data';
import { RecallsUnitedVehicleData } from '../../pages/recalls-united/recalls-united';
import serverSideService from '../../../services/server-side-service/server-side-service';

export interface RecallsInformationSectionProps {
    vehicle: RecallsUnitedVehicleData;
    recallsContent: RecallsUnitedContent;
    recallsDataResponse: RecallsApiResponseWithLoading | null | undefined;
    isWebview: boolean;
    showRecalls: boolean;
    showCsp: boolean;
}
export const scrollToRecallsResults = () => {
    const scrollPadding = 70;
    const section = document.getElementById('recalls-information-section');
    const scrollHeight = (section?.offsetTop || 0) - scrollPadding;
    if (serverSideService.isClientSide() && section) {
        window.scrollTo({
            top: scrollHeight,
            behavior: 'smooth',
        });
    }
};
const RecallsInformationSection = (props: RecallsInformationSectionProps) => {
    const {
        recallsContent,
        recallsDataResponse,
        vehicle,
        isWebview,
        showRecalls,
        showCsp,
    } = props;

    const recallsData = recallsDataResponse?.recallData;
    const checkForDoNotDrive =
        (recallsContent.doNotDriveTitle &&
            recallsData?.nhtsa?.find(nhtsa => {
                return nhtsa.descriptionLang
                    .toLowerCase()
                    .includes(recallsContent.doNotDriveText?.toLowerCase());
            })) ||
        (recallsContent.doNotDriveTitle &&
            recallsData?.recalls?.find(recalls => {
                return recalls.descriptionLang
                    .toLowerCase()
                    .includes(recallsContent.doNotDriveText?.toLowerCase());
            }));
    const { desktopOrLarger } = useBreakpoints();
    const exemptWordsList = useExemptWordsContent();
    return (
        <div
            className="recalls-information-section"
            id="recalls-information-section"
        >
            {vehicle.error ? (
                <div className="recalls-api-failure-message">
                    {recallsContent.apiFailureErrorMessage}
                </div>
            ) : (
                <>
                    {vehicle.loading ? (
                        <ActivityIndicator />
                    ) : (
                        vehicle.vehicleAttributes?.model && (
                            <header className="recalls-vin-and-model">
                                <h2 className="recalls-model-name">
                                    {nameplateMakeModelYearUtil(
                                        vehicle.vehicleAttributes.model,
                                        vehicle.vehicleAttributes.year
                                    )}
                                </h2>
                                {vehicle.vehicleAttributes.vin && (
                                    <span className="recalls-vin">{`${recallsContent.vinLabel}: ${vehicle.vehicleAttributes.vin}`}</span>
                                )}
                            </header>
                        )
                    )}
                    {recallsDataResponse?.loading ? (
                        <ActivityIndicator className="recalls-united-recalls-list-loader" />
                    ) : (
                        vehicle.vehicleAttributes?.model && (
                            <>
                                {checkForDoNotDrive && showRecalls && (
                                    <div className="recalls-do-not-drive">
                                        <img
                                            loading="lazy"
                                            src={errorIcon}
                                            alt=""
                                            height={24}
                                            width={24}
                                        />
                                        <div className="do-not-drive-title">
                                            {recallsContent.doNotDriveTitle}
                                        </div>
                                    </div>
                                )}
                                {desktopOrLarger ? (
                                    <RecallsListDesktop
                                        content={recallsContent}
                                        recallsData={recallsData}
                                        exemptWordsList={exemptWordsList}
                                        vin={vehicle.vehicleAttributes.vin}
                                        desktopOrLarger={desktopOrLarger}
                                        showRecalls={showRecalls}
                                        showCsp={showCsp}
                                        isWebview={isWebview}
                                        onClickScroll={scrollToRecallsResults}
                                    />
                                ) : (
                                    <RecallsListMobile
                                        content={recallsContent}
                                        recallsData={recallsData}
                                        exemptWordsList={exemptWordsList}
                                        vin={vehicle.vehicleAttributes.vin}
                                        showRecalls={showRecalls}
                                        showCsp={showCsp}
                                        isWebview={isWebview}
                                    />
                                )}
                            </>
                        )
                    )}
                </>
            )}
        </div>
    );
};

export default RecallsInformationSection;
